import { useEffect } from "react";
import "@/App.css";
import Inventory from "@/pages/Inventory";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <Inventory />
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

export default App;
